import React from 'react';
import { categoryConfigurations } from './categoryConfig';

export const categoryEmojiMap: Record<string, React.ReactNode | string> = 
  Object.fromEntries(
    categoryConfigurations.map(config => [
      config.key,
      config.imageSource ? (
        <img
          src={config.imageSource}
          alt={config.imageAlt}
          style={{ width: '1em', height: '1em', lineHeight: '1em' }}
        />
      ) : config.emoji
    ])
  ); 